import Image from '@commons/image/Image'
import { VisualProps } from '@commons/visual/types'

export default function Visual({
    desktop = null,
    alt_text = null
}: VisualProps) {
    if (!desktop) {
        return null
    }

    return (
        <>
            <Image src={desktop} alt={alt_text} />
        </>
    )
}
